<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Notification
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- <v-col sm="4">
              <v-autocomplete
                outlined
                v-model="form.user_id"
                :items="userItems"
                label="User"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.user_id"
              ></v-autocomplete>
            </v-col> -->
            <v-col sm="4">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.title"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-textarea
                v-model="form.descriptions"
                outlined
                label="Message"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.descriptions"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.type"
                :items="itemTypes"
                label="Notification Type *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.type"
              ></v-autocomplete>
            </v-col>
            <!-- <v-col sm="4">
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file.value = null), (image_path = null)"
                >Remove</v-btn
              >

              <div id="preview" v-if="image_path" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img
                  :src="image_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col> -->
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Notification
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "NotificationCreatePage",
  data() {
    return {
      form: {
        title: "",
        descriptions: "",
      },
      image_path: "",
      itemTypes: [
        { id: 1, text: "ORDERS", value: 1 },
        { id: 2, text: "PROMOTIONS", value: 2 },
      ],
      isLoading: false,
      is_restored_gift: false,
    };
  },

  methods: {
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/notifications", this.form);
        // this.notifications = notifications.data.data;
        await this.handleFileUpload();
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/notifications");
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      if (this.$refs.file != null) {
        let attachment = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append("id", this.banners.id);
        formData.append("image_path", attachment);
        await axios
          .post("upload_banners_image", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch(function (error) {
            console.log(error);
            console.log("FAILURE!!");
          });
      }
    },
    onFileChange() {
      this.warningImageLoader = false;
      this.file = this.$refs.file?.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          this.imageLoader = false;
          this.image_path = URL.createObjectURL(this.file);
          this.imageErrors = "";
        };
        img.src = evt.target.result;
      };

      reader.onerror = (evt) => {
        console.error(evt);
      };
      // this.image_path = URL.createObjectURL(this.file);
    },
  },
};
</script>
